export default __webpack_public_path__ + "static/media/cp_impact.3e189a26.pdf";